




import React, { useEffect, useState } from 'react';

import axios from 'axios';


const Grocerystandardorder = () => {
    const [activeTab, setActiveTab] = useState('Status');
    const [data, setData] = useState([]);
    const [orders, setOrders] = useState([]);

    const [selectedItems, setSelectedItems] = useState([]);

    const [vendorId, setVendorId] = useState(null);
    const [allOrders, setAllOrders] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedDate, setSelectedDate] = useState(""); // format: YYYY-MM-DD

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const exportToCSV = () => {
        if (filteredData.length === 0) {
            alert("No data to export!");
            return;
        }

        // 1️⃣ Build CSV header
        const headers = [
            "S.No",
            "Order ID",
            "Date",
            "Category",
            "Type",
            "Name",
            "Payment",
            "Order Status",
            "Amount",
        ];

        // 2️⃣ Build CSV rows
        const rows = filteredData.map((item, index) => [
            index + 1,
            item.orderId,
            new Date(item.orderDateAndTime).toLocaleDateString("en-GB"),
            item.appType,
            item.orderType || item.orderService,
            item.userName,
            item.paymentMethod,
            item.status,
            Math.round(item.grandTotal),
        ]);

        // 3️⃣ Combine header + rows
        const csvContent =
            [headers, ...rows]
                .map((row) => row.map((v) => `"${v}"`).join(",")) // wrap each value in quotes
                .join("\n");

        // 4️⃣ Create a blob and download
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `orders_${new Date().toISOString().split("T")[0]}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    // Fetch orders from API
    useEffect(() => {
        if (!vendorId) return;

        const fetchOrders = async () => {
            const token = localStorage.getItem("authToken");
            const vendorId = localStorage.getItem("vendorId");
            if (!token) {
                console.error("Authorization token missing");
                return;
            }

            try {
                const response = await axios.get(
                    `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/getall/${vendorId}`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );

                const orders = response.data || [];
                console.log("✅ Orders fetched:", orders);

                // 🟢 Show data in alert (formatted for readability)
                // alert("Fetched Orders:\n\n" + JSON.stringify(orders, null, 2));

                setAllOrders(orders);
                setFilteredData(orders);
            } catch (error) {
                console.error("❌ Error fetching orders:", error);
                alert("Error fetching orders:\n" + (error.response?.data?.message || error.message));
            }
        };

        fetchOrders();
    }, [vendorId]);



    useEffect(() => {
        if (!vendorId) return;

        const fetchOrders = async () => {
            const token = localStorage.getItem("authToken");
            if (!token) {
                console.warn("Auth token missing. Skipping order fetch.");
                return;
            }

            try {
                // 1️⃣ Fetch normal orders
                const ordersRes = await axios.get(
                    `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/getall/${vendorId}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                // Filter normal orders based on status
                const processingOrders = ordersRes.data.filter(order =>
                    ["CONFIRMED", "PROCESSING", "ORDER_IS_READY", "WAITING_FOR_PICKUP"].includes(order.status)
                );

                // 2️⃣ Fetch TABLE_DINE_IN orders for relevant statuses
                const dineInStatuses = ["PROCESSING", "BEING_PREPARED", "ORDER_IS_READY", "WAITING_FOR_PICKUP", "COMPLETED"];
                const dineInPromises = dineInStatuses.map(status =>
                    axios.get(
                        `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/${status}`,
                        { headers: { Authorization: `Bearer ${token}` } }
                    )
                );

                const dineInResponses = await Promise.all(dineInPromises);
                let dineInOrders = dineInResponses.flatMap(res => res.data || []);

                // Filter TABLE_DINE_IN orders by cartItems status
                dineInOrders = dineInOrders.filter(order =>
                    Array.isArray(order.cartItems) &&
                    order.cartItems.some(item =>
                        ["PROCESSING", "BEING_PREPARED", "ORDER_IS_READY", "WAITING_FOR_PICKUP"].includes(item.orderStatus)
                    )
                );

                // 3️⃣ Combine normal and TABLE_DINE_IN orders and remove duplicates
                const combinedOrders = [...processingOrders, ...dineInOrders];
                const uniqueOrders = combinedOrders.filter(
                    (order, index, self) =>
                        index === self.findIndex(
                            o => (o.cartId && o.cartId === order.cartId) || (o.orderId && o.orderId === order.orderId)
                        )
                );

                setOrders(uniqueOrders);
                // console.log("✅ Final Unique Orders:", uniqueOrders);
            } catch (error) {
                console.error("❌ Failed to fetch orders:", error.response?.data || error.message);
            }
        };

        fetchOrders();
        const intervalId = setInterval(fetchOrders, 1000); // Fetch every 1 second
        return () => clearInterval(intervalId);
    }, [vendorId]);







    // Filter orders whenever selectedDate changes
    useEffect(() => {
        if (!selectedDate) {
            setFilteredData(allOrders); // show all if no date selected
            return;
        }

        const filtered = allOrders.filter((order) => {
            const orderDate = new Date(order.orderDateTime)
                .toISOString()
                .split("T")[0]; // format YYYY-MM-DD
            return orderDate === selectedDate;
        });

        setFilteredData(filtered);
    }, [selectedDate, allOrders]);




    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        if (storedVendorId) {
            setVendorId(storedVendorId);
        }
    }, []);

    const [combinedData, setCombinedData] = useState([]);

    useEffect(() => {
        if (!vendorId) return;

        const fetchData = () => {
            const token = localStorage.getItem("authToken"); // ✅ Retrieve token from storage
            if (!token) {
                console.warn("No auth token found. Skipping fetch.");
                return;
            }

            axios
                .get(
                    `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/getall/${vendorId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`, // ✅ Include token in header
                        },
                    }
                )
                .then((res) => setData(res.data))
                .catch((err) =>
                    console.error("Error fetching orders with token:", err.response?.data || err.message)
                );
        };

        fetchData(); // initial fetch

        const interval = setInterval(fetchData, 1000); // fetch every 1 second

        return () => clearInterval(interval); // cleanup
    }, [vendorId]);







    const [showDetails, setShowDetails] = useState(false);

    const orderStages = ["Order Placed", "Order Preparing", "Order is Ready", "Order on the way", "Order Delivered"];

    const styles = {
        card: { border: '1px solid #ccc', padding: '16px', margin: '16px', borderRadius: '10px', background: "linear-gradient(to right, #f46b45, #eea849)", },
        header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
        orderId: { margin: 0, fontWeight: "bold" },
        date: { fontSize: '18px', color: '#000', fontWeight: "bold" },
        pickupBtn: { background: '#28a745', color: '#fff', border: 'none', padding: '6px 12px', cursor: 'pointer', borderRadius: '5px', fontWeight: "bold", },
        tracker: { marginTop: '10px', display: 'flex', alignItems: 'center', fontWeight: "bold" },
        statusBox: { background: '#eee', padding: '8px 12px', borderRadius: '5px' },
        arrow: { margin: '0 5px' },
        dropdownBtn: { background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', },
        itemList: { marginTop: '10px', fontWeight: "bold" },
        itemRow: { display: 'flex', justifyContent: 'space-between', padding: '4px 0', borderBottom: '1px solid #ddd' }
    };






    return (

        <div>


            <div className="container-fluid">
                <div className="Row">
                    <div className="col-lg-2"></div>
                    <div className="Col-lg-7">
                        <div className="order-table-container">
                            <style>
                                {`
          .order-table-container {
            padding: 0px;
            font-family: Arial, sans-serif;
          }

          .filters {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            flex-wrap: wrap;
            gap: 10px;
            
            
          }

          .filters select {
            padding: 8px 10px;
            border-radius: 5px;
            border: 1px solid #ccc;
            margin-right: 10px;
            min-width: 120px;
            background-color: #b15cd6;
            color: #fff;
            font-weight:bold;
          }

          .filters button {
            padding: 10px 20px;
            background-color: #b15cd6;
            color: #fff;
            border: none;
            border-radius: 5px;
            font-weight: bold;
            cursor: pointer;
            white-space: nowrap;
          }

          .table-wrapper {
            overflow-x: auto;
            margin-top: 0px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            min-width: 800px;
          }

          thead tr {
            background-color: #b15cd6;
          }

          th, td {
            padding: 10px;
            border: 1px solid #ddd;
            text-align: center;
            font-size: 14px;
          }

          tbody tr:nth-child(even) {
            background-color: #f9f9f9;
          }

          tbody tr:nth-child(odd) {
            background-color: #ffffff;
          }

          @media (max-width: 768px) {
            .filters {
              flex-direction: column;
              align-items: stretch;
            }

            .filters select {
              width: 100%;
              margin-right: 0;
            }

            .filters button {
              width: 100%;
              margin-top: 10px;
            }

            table {
              font-size: 12px;
            }
          }
        `}
                            </style>

                            {/* Filter Row */}
                            <div className="filters">
                                <div>
                                    <button>
                                        <input
                                            type="date"
                                            value={selectedDate}
                                            onChange={(e) => setSelectedDate(e.target.value)}
                                            style={{ background: "rgb(177 92 214)", color: "#fff", border: "none" }}
                                        /></button>
                                </div>
                                <button onClick={exportToCSV}>Export</button>
                            </div>

                            {/* Table */}
                            <div style={{ marginTop: "-15px" }} className="table-wrapper">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Order ID</th>
                                            <th>Date</th>
                                            {/* <th>Category</th>
                                            <th>Type</th> */}
                                            <th>Name</th>
                                            <th>Payment</th>
                                            <th>Order Status</th>
                                            <th>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData.length === 0 ? (
                                            <tr>
                                                <td colSpan="9" style={{ textAlign: "center" }}>
                                                    No orders for selected date
                                                </td>
                                            </tr>
                                        ) : (
                                            filteredData.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.orderId}</td>
                                                    <td>{new Date(item.orderDateTime).toLocaleDateString("en-GB")}</td>

                                                    <td>{item.userName}</td>
                                                    <td>{item.paymentMethod}</td>
                                                    <td>{item.orderStatus}</td>
                                                    <td>₹{Math.round(item.total)}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>

                            </div>
                        </div>

                        {/* Left Section */}

                    </div>
                </div>
            </div>
        </div>


    );
};
const tableHeaderStyle = {
    border: '1px solid #ddd',
    textAlign: 'center',
    fontWeight: 'bold',
    backgroundColor: '#b15cd6',
    color: 'white',
};
const tableCellStyle = {
    border: '1px solid #ddd',
    textAlign: 'center',
};
const evenRowStyle = {
    backgroundColor: '#f9f9f9',
};
const oddRowStyle = {
    backgroundColor: '#fff',
};
const dropdownStyle = {
    height: "35px",
    marginTop: '20px',
    marginRight: "10px",
    borderRadius: "4px",
    fontWeight: "bold",
    backgroundColor: "#b15cd6",
    color: "#fff",
    marginBottom: "-10px"
};

const exportButtonStyle = {
    height: '35px',
    marginTop: "20px",
    borderRadius: "4px",
    border: "none",
    backgroundColor: "#b15cd6",
    color: "white",
    fontWeight: 'bold'
};


export default Grocerystandardorder;
